module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.9 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修正 onHide 回调被错误调用 #1023 @jsonviewer")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime-range.html"
    }
  }, [_vm._v("DatetimeRange")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 新组件 #970 @327326724")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更流畅的遮罩层动画")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持透明背景")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持背影颜色变量 @popup-background-color")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复向右快速滑动时左侧菜单可能会被滑出")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 插件调用时每次都重置为默认参数 #870 @jsonviewer")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/date.html"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加日期范围生成函数")]), _vm._v(" "), _c('li', [_vm._v("[feature] format 函数支持字符串参数")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/number.html"
    }
  }, [_vm._v("Number")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加数字范围生成函数")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d97e49a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-0d97e49a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.9-217.vue
// module id = 2031
// module chunks = 335